import React from 'react';
import PropTypes from 'prop-types';
import DragManager from 'utils/project-definition/drag-manager';

// Because Hammer ruined my day
export default class DragLayer extends React.Component {
  constructor(props) {
    super(props);

    const {
      onStartDrag,
      onFirstDrag,
      onDrag,
      onStopDrag,
      onClick,
      isDrag,
    } = props;

    this.dragManager = new DragManager({
      onStartDrag: this.bindFunc(onStartDrag),
      onFirstDrag: this.bindFunc(onFirstDrag),
      onDrag: this.bindFunc(onDrag),
      onStopDrag: this.bindFunc(onStopDrag),
      onClick: this.bindFunc(onClick),
      isDrag: this.bindFunc(isDrag),
    });
    this.pressHandler = this.pressHandler.bind(this);
  }

  bindFunc(func) {
    if (!func || !func.bind) {
      return func;
    }

    return func.bind(this);
  }

  pressHandler(evt) {
    const { dragManager, props } = this;

    dragManager.onDrag = props.onDrag;
    dragManager.startDrag(evt);
  }

  render() {
    return (
      <div
        role="button"
        className={this.props.className}
        style={this.props.style}
        onMouseDown={this.pressHandler}
        onTouchStart={this.pressHandler}
      >
        {this.props.children}
      </div>
    );
    //
  }

  static calculateDelta(info, prevInfo, result) {
    return DragManager.calculateDelta(info, prevInfo, result);
  }
}

DragLayer.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,

  onStartDrag: PropTypes.func,
  onFirstDrag: PropTypes.func,
  onDrag: PropTypes.func,
  onStopDrag: PropTypes.func,
  onClick: PropTypes.func,
  isDrag: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/configuration/drag-layer.jsx